<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >证书管理</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名或邮箱"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书类型"
                            field="cerType"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.cerType"
                                    placeholder="全部"
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value=""
                                        label="全部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="RPA"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="Python"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="AI应用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书类别"
                            field="cerLevel"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.cerLevel"
                                    placeholder="全部"
                                    style="width: 160px"
                                >
                                    <vxe-option
                                        value=""
                                        label="全部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="A"
                                        label="开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="B"
                                        label="高级开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="C"
                                        label="讲师证书"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button
                                    v-if="isAdmin === '1'"
                                    status="success"
                                    @click="addCer"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            title="删除"
                            width="60"
                            show-overflow
                            v-if="false"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="查看" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search-plus"
                                    @click="view(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="user_name"
                            title="姓名"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="JobName"
                            title="部门"
                            width="70"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="user_mail"
                            title="邮箱"
                            width="200"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="type_name"
                            title="证书类型"
                            width="100"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="type_level_name"
                            title="证书类别"
                            width="140"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="cer_no"
                            title="证书编号"
                            width="120"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="cer_date"
                            title="证书日期"
                            width="130"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="verify_code"
                            title="校验码"
                            width="170"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="creation_date"
                            title="创建日期"
                            width="130"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- 新增-->
            <vxe-modal
                v-model="formAdd.isShow"
                @close="closeWinEvent"
                :title="formAdd.title"
                width="680"
                height="400"
                ref="rFormN"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formAdd.formData"
                        :rules="formAdd.formRules"
                        title-align="right"
                        ref="nForm"
                        title-width="60"
                        style="height: 100%"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>

                        <vxe-form-item
                            title="证书类型"
                            field="type_id"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formAdd.formData.type_id"
                                    placeholder="请选择..."
                                >
                                    <vxe-option
                                        value="1"
                                        label="RPA"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="Python"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="AI应用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书类别"
                            field="type_id"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formAdd.formData.type_level"
                                    placeholder="请选择..."
                                >
                                    <vxe-option
                                        value="A"
                                        label="开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="B"
                                        label="高级开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="C"
                                        label="讲师证书"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书日期"
                            field="cer_date"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formAdd.formData.cer_date"
                                    type="date"
                                    placeholder="请选择证书日期"
                                    clearable
                                    transfer
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="UserEmail"
                            span="22"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formAdd.formData.UserEmail"
                                    readonly
                                    placeholder="请选择业务人员"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button @click="selectUser(1)"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            align="center"
                            span="24"
                            style="
                                position: absolute;
                                bottom: 0;
                                margin-top: 30px;
                            "
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.saveButDisable"
                                    @click="createCer"
                                    icon="fa fa-save"
                                    status="success"
                                    style="margin-top: 30px"
                                    >生成
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 编辑-->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="680"
                height="400"
                ref="rForm"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="nForm"
                        title-width="60"
                        style="height: 100%"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>

                        <vxe-form-item
                            title="证书类型"
                            field="type_id"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    :disabled="formInput.allInputDisable"
                                    v-model="formInput.formData.type_id"
                                    placeholder="请选择..."
                                >
                                    <vxe-option
                                        value="1"
                                        label="RPA"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="Python"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="AI应用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书类别"
                            field="type_id"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    :disabled="formInput.allInputDisable"
                                    v-model="formInput.formData.type_level"
                                    placeholder="请选择..."
                                >
                                    <vxe-option
                                        value="A"
                                        label="开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="B"
                                        label="高级开发者证书"
                                    ></vxe-option>
                                    <vxe-option
                                        value="C"
                                        label="讲师证书"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="user_name"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    :disabled="formInput.allInputDisable"
                                    v-model="formInput.formData.user_name"
                                    readonly
                                    placeholder="请选择业务人员"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    @click="selectUser(1)"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书编号"
                            field="cer_no"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    :disabled="formInput.allInputDisable"
                                    v-model="formInput.formData.cer_no"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="校验码"
                            field="verify_code"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    :disabled="formInput.allInputDisable"
                                    v-model="formInput.formData.verify_code"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="证书日期"
                            field="cer_date"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.cer_date"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            align="center"
                            span="24"
                            style="
                                position: absolute;
                                bottom: 0;
                                margin-top: 30px;
                            "
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.saveButDisable"
                                    @click="save"
                                    icon="fa fa-save"
                                    status="success"
                                    style="margin-top: 30px"
                                    >保存
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 查看-->
            <vxe-modal
                v-model="isView"
                title="查看证书"
                width="950"
                height="650"
                ref="rFormView"
                show-zoom
                resize
            >
                <template #default>
                    <div style="padding-left: 20px">
                        <div id="pdfDom">
                            <div :class="proBox">
                                <div :class="bandvenucia">
                                    <img
                                        src="@/static/images/venucia.png"
                                        height="80"
                                        alt=""
                                    />
                                </div>
                                <div :class="bandnissan">
                                    <img
                                        src="@/static/images/band.png"
                                        height="160"
                                        alt=""
                                    />
                                </div>
                                <div :class="bandinfinity">
                                    <img
                                        src="@/static/images/infinity.png"
                                        height="80"
                                        alt=""
                                    />
                                </div>
                                <p :class="tit">{{ cer_info.cer_name }}</p>

                                <p :class="con">
                                    <span class="con-name">{{
                                        cer_info.user_name
                                    }}</span>
                                    同学，{{ cer_info.cer_desc }}。
                                </p>
                                <div class="con-unit">
                                    <p>数字化转型卓越中心</p>
                                    <p class="time">{{ cer_info.cer_date }}</p>
                                </div>
                                <div class="cer-no">
                                    <p class="proid">
                                        <span>证书编号：</span>
                                        <span>{{ cer_info.cer_no }}</span>
                                    </p>
                                    <p class="proid">
                                        <span>证书校验码：</span>
                                        <span>{{ cer_info.verify_code }}</span>
                                    </p>
                                </div>
                                <div :class="cerlogo">
                                    <img
                                        src="@/static/images/coe02.png"
                                        height="35"
                                        alt=""
                                    />
                                    <div
                                        style="
                                            border-left: solid 1px #9fa1a1;
                                            margin-left: 5px;
                                            margin-right: 5px;
                                        "
                                    ></div>

                                    <img
                                        src="@/static/images/DFN.png"
                                        height="40"
                                        alt=""
                                    />
                                </div>

                                <div class="chapter" v-show="isShow">
                                    <canvas
                                        id="chapterCanvas"
                                        width="150"
                                        height="150"
                                    ></canvas>
                                </div>
                            </div>
                        </div>

                        <span slot="footer" class="dialog-footer">
                            <vxe-switch
                                v-model="downType"
                                open-label="图片下载"
                                close-label="pdf下载"
                                style="margin-right: 20px"
                            >
                            </vxe-switch>
                            <vxe-checkbox
                                v-model="isShow"
                                style="margin-right: 20px"
                                >添加盖章</vxe-checkbox
                            >
                            <vxe-button
                                @click="dialogVisible = false"
                                v-if="false"
                                >取 消</vxe-button
                            >
                            <vxe-button
                                type="primary"
                                @click="getPdf('#proBox')"
                                >下载</vxe-button
                            >
                            <vxe-button type="primary" @click="preview"
                                >预览证书</vxe-button
                            >
                        </span>
                    </div>
                </template>
            </vxe-modal>
            <!-- 选择用户-->
            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item title="关键字" :item-render="{}">
                                <template #default>
                                    <vxe-input
                                        v-model="userTablePager.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div>
                                        <template
                                            v-for="(item, index) in formAdd
                                                .formData.UserNameEmail"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="uid"
                                title="uid"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="handlePageChangeUser"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import { VXETable } from "vxe-table";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
    name: "CertificateList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            formData: {
                searchKey: "",
                cerType: "",
                cerLevel: "",
            },
        });
        const formInput = reactive({
            title: "编辑证书",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            formData: {
                id: "",
                type_id: "",
                type_level: "",
                user_id: "",
                user_name: "",
                cer_no: "",
                verify_code: "",
                cer_date: "",
                enabled: "1",
            },
            formRules: {
                id: [{ required: true, message: "流程名称不能为空" }],
                type_id: [{ required: true, message: "流程ID不能为空" }],
                user_id: [{ required: true, message: "虚拟机不能为空" }],
                user_name: [{ required: true, message: "业务人员不能为空" }],
                UserName: [{ required: true, message: "业务人员不能为空" }],
                cer_no: [{ required: true, message: "优先级不能为空" }],
                verify_code: [{ required: true, message: "数据来源不能为空" }],
                cer_date: [{ required: true, message: "证书日期不能为空" }],
            },
        });

        const formAdd = reactive({
            title: "生成证书",
            isShow: false,
            formData: {
                type_id: "",
                type_level: "",
                cer_date: "",
                UserName: "", //业务邮箱，返回后台保存值
                UserNameEmail: [], //显示中显示值
                UserEmail: "", //选择后的显示值
            },
            formRules: {
                type_id: [{ required: true, message: "证书类型不能为空" }],
                UserEmail: [{ required: true, message: "业务人员不能为空" }],
                type_level: [{ required: true, message: "证书类别不能为空" }],
                cer_date: [{ required: true, message: "证书日期不能为空" }],
            },
        });

        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const cer_info = reactive({
            id: "",
            user_name: "",
            cer_no: "",
            verify_code: "",
            cer_date: "",
            cer_name: "",
            cer_desc: "",
            type_id: "",
        });

        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            editType: 1, //1 新增 2 编辑
            tableHeight: 0,
            iShowSelectUser: false,
            formInput,
            formAdd,
            userTablePager,
            dtUser: null,
            cer_info,
            isView: false,
            isShow: true, //盖章
            downType: true, // false为 pdf , true为图片
            proBox: "proBox",
            bandvenucia: "band-venucia",
            bandnissan: "band-nissan",
            bandinfinity: "band-infinity",
            tit: "tit",
            con: "con",
            cerlogo: "cer-logo",
            dialogVisible: false,
            isAdmin: false,
        };
    },
    methods: {
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.cerType,
                    this.toolbar.formData.cerLevel,
                ],
            };
            this.$api.systemManageAPI
                .getCertificateList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addCer() {
            this.formAdd.formData = {
                type_id: "",
                type_level: "",
                UserName: "", //业务邮箱，返回后台保存值
                UserNameEmail: [], //显示中显示值
                UserEmail: "", //选择后的显示值
            };
            this.formAdd.isShow = true;
        },
        async createCer() {
            const $rForm = this.$refs.nForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const params = {
                type_id: this.formAdd.formData.type_id,
                UserName: this.formAdd.formData.UserName,
                creator: this.$store.state.userID,
                type_level: this.formAdd.formData.type_level,
                cer_date: this.formAdd.formData.cer_date,
            };
            this.$api.systemManageAPI
                .createCertificate(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }

                    VXETable.modal.message({
                        content: "生成成功",
                        status: "success",
                    });

                    this.findData();
                    this.formAdd.isShow = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //保存
        async save() {
            const $rForm = this.$refs.nForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const params = this.formInput.formData;

            this.$api.systemManageAPI
                .updateCertificate(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "保存成功",
                        status: "success",
                    });
                    this.formInput.isShow = false;
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.alert({ content: error, status: "error" });
                    console.log(error);
                });
        },
        //编辑
        editEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [row.id],
            };
            this.$api.systemManageAPI
                .getCertificateOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;

                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //查看
        view(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [row.id],
            };
            this.$api.systemManageAPI
                .getCertificateOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    if (res.data.Data != null) {
                        this.cer_info = res.data.Data;
                    } else {
                        this.cer_info = {
                            id: "",
                            user_name: "",
                            cer_no: "",
                            verify_code: "",
                            cer_date: "",
                            cer_name: "",
                            cer_desc: "",
                            type_id: "",
                        };
                    }

                    if (this.cer_info.type_id == "1") {
                        this.proBox = "proBox";
                        this.bandvenucia = "band-venucia";
                        this.bandnissan = "band-nissan";
                        this.bandinfinity = "band-infinity";
                        this.tit = "tit";
                        this.con = "con";
                        this.cerlogo = "cer-logo";
                    } else if (this.cer_info.type_id == "3") {
                        this.proBox = "proBox-ai";
                        this.bandvenucia = "band-venucia";
                        this.bandnissan = "band-nissan";
                        this.bandinfinity = "band-infinity";
                        this.tit = "tit";
                        this.con = "con";
                        this.cerlogo = "cer-logo";
                    } else {
                        this.proBox = "proBox-python";
                        this.bandvenucia = "band-venucia-python";
                        this.bandnissan = "band-nissan-python";
                        this.bandinfinity = "band-infinity-python";
                        this.tit = "tit-python";
                        this.con = "con-python";
                        this.cerlogo = "cer-logo-python";
                    }
                    this.isView = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //删除
        async removeRowEvent(row) {
            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                this.$api.systemManageAPI
                    .delCertificate(Qs.stringify({ cer_id: row.id }))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        selectUser(type) {
            this.userTablePager.searchKey = "";
            this.findUserData();
            this.iShowSelectUser = true;
        },
        confirmSelectUser() {
            this.iShowSelectUser = false;
        },
        //删除用户
        clearUser(useremail) {
            let idx = -1;

            this.formAdd.formData.UserNameEmail.forEach(function (item, index) {
                if (item.ID == useremail) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formAdd.formData.UserEmail.toString().split(";");
            tmpname = this.formAdd.formData.UserName.toString().split(";");
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formAdd.formData.UserEmail = tmpId.join(";"); //显示值
            this.formAdd.formData.UserName = tmpname.join(";"); //邮箱
            let count = 0;
            if (this.formAdd.formData.UserName.toString() != "") {
                count =
                    this.formAdd.formData.UserName.toString().split(";").length;
            }
            this.formAdd.formData.UserNameEmail = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formAdd.formData.UserNameEmail.push({
                    Name: this.formAdd.formData.UserEmail.toString().split(";")[
                        i
                    ],
                    ID: this.formAdd.formData.UserName.toString().split(";")[i],
                });
            }
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }

            //判断是否已选择过
            if (this.formAdd.formData.UserName.toString() != "") {
                for (let item of this.formAdd.formData.UserName.toString().split(
                    ";"
                )) {
                    if (item == record.UserMail) {
                        VXETable.modal.message({
                            content: "该人员已选择",
                            status: "warning",
                        });
                        return;
                    }
                }
            }

            if (
                this.formAdd.formData.UserEmail == null ||
                this.formAdd.formData.UserEmail.toString() == ""
            ) {
                this.formAdd.formData.UserEmail =
                    record.UserName + "(" + record.UserMail + ")";
            } else {
                this.formAdd.formData.UserEmail +=
                    ";" + record.UserName + "(" + record.UserMail + ")";
            }
            if (
                this.formAdd.formData.UserName == null ||
                this.formAdd.formData.UserName.toString() == ""
            ) {
                this.formAdd.formData.UserName = record.UserMail;
            } else {
                this.formAdd.formData.UserName += ";" + record.UserMail;
            }

            let count =
                this.formAdd.formData.UserName.toString().split(";").length;
            this.formAdd.formData.UserNameEmail = [];
            for (let i = 0; i < count; i++) {
                this.formAdd.formData.UserNameEmail.push({
                    Name: this.formAdd.formData.UserEmail.toString().split(";")[
                        i
                    ],
                    ID: this.formAdd.formData.UserName.toString().split(";")[i],
                });
            }
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey, ""],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        handlePageChangeUser() {
            this.findUserData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.cerType = "";
            this.toolbar.formData.cerLevel = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        closeWinEvent() {
            this.findData();
        },
        preview() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (!this.isCanvas) {
                    // 只绘画一次
                    this.isCanvas = true;
                    this.getChapter();
                }
            });
        },
        // 生成印章
        getChapter() {
            const canvas = document.getElementById("chapterCanvas");
            const context = canvas.getContext("2d");

            const text = "xxx专用章";
            const companyName = "数字化转型卓越中心";
            //  context.translate(0, 0);
            // context.clearRect(0, 0, 200, 200);//清除整个画布
            // 绘制印章边框
            const width = canvas.width / 2;
            const height = canvas.height / 2;
            context.lineWidth = 3;
            context.strokeStyle = "#cf0c0c";
            context.beginPath();
            context.arc(width, height, 60, 0, Math.PI * 2); //宽、高、半径
            context.stroke();

            //画五角星
            create5star(context, width, height, 15, "#cf0c0c", 0);

            // 绘制印章名称
            context.font = "20px 宋体";
            context.textBaseline = "middle"; //设置文本的垂直对齐方式
            context.textAlign = "center"; //设置文本的水平对对齐方式
            context.lineWidth = 1;
            context.strokeStyle = "#cf0c0c";
            // context.strokeText(text, width, height + 30); // 名称 xx专用章

            // 绘制印章单位
            context.translate(width, height); // 平移到此位置,
            context.font = "20px 宋体";
            let count = companyName.length; // 字数
            let angle = (5 * Math.PI) / (3 * (count - 1)); // 字间角度
            let chars = companyName.split("");
            let c;
            for (let i = 0; i < count; i++) {
                c = chars[i]; // 需要绘制的字符
                if (i == 0) {
                    context.rotate((4 * Math.PI) / 6); // 文字起始位置
                } else {
                    context.rotate(angle);
                }

                context.save();
                context.translate(45, 0); // 平移到此位置,此时字和x轴垂直，公司名称和最外圈的距离
                context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
                context.strokeText(c, 0, 0); // 此点为字的中心点
                context.restore();
            }

            //绘制五角星
            function create5star(context, sx, sy, radius, color, rotato) {
                context.save();
                context.fillStyle = color;
                context.translate(sx, sy); //移动坐标原点
                context.rotate(Math.PI + rotato); //旋转
                context.beginPath(); //创建路径
                let x = Math.sin(0);
                let y = Math.cos(0);
                let dig = (Math.PI / 5) * 4;
                for (let i = 0; i < 5; i++) {
                    //画五角星的五条边
                    x = Math.sin(i * dig);
                    y = Math.cos(i * dig);
                    context.lineTo(x * radius, y * radius);
                }
                context.closePath();
                context.stroke();
                context.fill();
                context.restore();
            }
        },
        getPdf() {
            let title = this.htmlTitle; // 导出名称
            let type = this.downType; // 导出类型 true ->图片 false-> pdf
            let htmlID = document.getElementById("pdfDom");
            // window.pageYoffset = 0; // 如果有滚动条影响，会导致导出的内容不全，可以直接设置导出前置顶
            // document.documentElement.scrollTop = 0;
            // document.body.scrollTop = 0;
            html2Canvas(htmlID, {
                allowTaint: true,
                // scrollY: 50, // 偏移量吧，如果有滚动条影响，但是不想设置滚动条置顶， 可以设置这个，但是要计算滚动了多少
                // scrollX:0,
                //x:0, // 距离左边距离
                // y:10,
                //width: 1000,
                //height: 800,
                // 下面两个用来提高清晰度
                dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
                scale: 4, //按比例增加分辨率
                useCORS: true, // 【重要】开启跨域配置
            }).then(function (canvas) {
                let contentWidth = canvas.width;
                let contentHeight = canvas.height;

                //一页pdf显示html页面生成的canvas高度
                let pageHeight = (contentWidth / 592.28) * 841.89;
                //未生成pdf的html页面高度
                let leftHeight = contentHeight;
                //页面偏移
                let position = 0;
                let imgWidth = 592.28;
                //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                // let imgHeight = 592.28 / contentWidth * contentHeight
                let imgHeight = (592.28 / contentWidth) * contentHeight;
                // 1.0 清晰度0-1
                let pageData = canvas.toDataURL("image/jpeg", 1.0);

                if (type) {
                    // 生成图片
                    //创建一个 a 标签，并设置 href 和 download 属性
                    const el = document.createElement("a");
                    // 设置 href 为图片经过 base64 编码后的字符串，默认为 png 格式
                    el.href = pageData;
                    el.download = title;
                    // 创建一个点击事件并对 a 标签进行触发
                    const event = new MouseEvent("click");
                    el.dispatchEvent(event);
                } else {
                    // 生成 pdf
                    //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
                    //当内容未超过pdf一页显示的范围，无需分页
                    // l 横向 默认竖向
                    let PDF = new JsPDF("l", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(
                            pageData,
                            "JPEG",
                            0,
                            0,
                            imgWidth,
                            imgHeight
                        );
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(
                                pageData,
                                "JPEG",
                                0,
                                position,
                                imgWidth,
                                imgHeight
                            );
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save(title + ".pdf");
                }
            });
        },
    },
    mounted() {
        this.findData();
        window.addEventListener("keydown", this.keydown);
        this.isAdmin = this.$store.state.isAdmin;
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style lang="scss">
.markup-tables {
    .table-wrapper {
        overflow: auto;
    }

    .va-table {
        width: 100%;
    }
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}

#pdfDom {
    /* 要想pdf周边留白，要在这里设置 */
    padding-left: 0px;
    padding-top: 0px;
    width: 862px;
}

.cer-logo {
    display: flex;
    position: absolute;
    bottom: 60px;
    left: 180px;
    text-align: center;
}

.cer-logo-python {
    display: flex;
    position: absolute;
    bottom: 60px;
    left: 190px;
    text-align: center;
}

.band-venucia {
    display: flex;
    position: absolute;
    top: 50px;
    left: 250px;
}

.band-nissan {
    display: flex;
    position: absolute;
    top: 10px;
    left: 340px;
}

.band-infinity {
    display: flex;
    position: absolute;
    top: 50px;
    left: 470px;
}

.band-venucia-python {
    display: flex;
    position: absolute;
    top: 60px;
    left: 250px;
}

.band-nissan-python {
    display: flex;
    position: absolute;
    top: 20px;
    left: 340px;
}

.band-infinity-python {
    display: flex;
    position: absolute;
    top: 60px;
    left: 470px;
}

.proBox {
    background-image: url("../../../static/images/bg03.jpg");
    backgroud-repeat: no-repeat;
    background-size: cover;
    width: 842px;
    height: 595px;
    padding: 90px 94px;
    padding-top: 120px;
    box-sizing: border-box;
    margin: 0 auto;
    position: relative;
    color: #000;
    font-family: SimSun;
}

.proBox-python {
    background-image: url("../../../static/images/bg04.jpg");
    backgroud-repeat: no-repeat;
    background-size: cover;
    width: 842px;
    height: 595px;
    padding: 90px 94px;
    padding-top: 120px;
    box-sizing: border-box;
    margin: 0 auto;
    position: relative;
    color: #000;
    font-family: SimSun;
}
.proBox-ai {
    background-image: url("../../../static/images/aibg.jpg");
    backgroud-repeat: no-repeat;
    background-size: cover;
    width: 842px;
    height: 595px;
    padding: 90px 94px;
    padding-top: 120px;
    box-sizing: border-box;
    margin: 0 auto;
    position: relative;
    color: #000;
    font-family: SimSun;
}

.tit {
    color: #cf0c0c;
    font-size: 36px;
    font-weight: 700;
    position: relative;
    text-align: center;
    top: -6px;
    left: 8px;
    letter-spacing: 15px;
    font-family: STHeiti;
    margin: 20px 0;
}

.tit-python {
    color: #cf0c0c;
    font-size: 36px;
    font-weight: 700;
    position: relative;
    text-align: center;
    top: 3px;
    left: 8px;
    letter-spacing: 15px;
    font-family: STHeiti;
    margin: 20px 0;
}

.proid {
    margin: 0;
    font-weight: 400;
    font-family: STHeiti;
    /* margin-right: 5px; */
}

.con {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin: 10px 0;
    line-height: 32px;
    text-indent: 2em;
}

.con-python {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 10px;
    line-height: 32px;
    text-indent: 2em;
    margin-top: 20px;
    margin-left: 0px;
    margin-right: 0px;
}

.con-name {
    font-family: 华文行楷, STXingkai;
    border-bottom: 2px solid #000;
    font-size: 30px;
}

.con-unit {
    font-size: 18px;
    font-weight: 700;
    position: absolute;
    right: 100px;
    bottom: 130px;
    text-align: center;
    letter-spacing: 3px;
}

.cer-no {
    position: absolute;
    left: 100px;
    bottom: 230px;
    text-align: left;
    font-size: 12px;
}

.con-unit p {
    margin: 5px 0;
}

.con-footer {
    font-size: 18px;
    font-weight: 700;
    position: absolute;
    bottom: 45px;
    left: 0;
    right: 0;
    text-align: center;
}

.chapter {
    border-radius: 50%;
    position: absolute;
    bottom: 90px;
    right: 122px;
}
</style>
